import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpService } from './http.service';
import { LoaderService } from './loader.service';
import { ToastrService } from 'ngx-toastr';
import { resolve } from 'url';
@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  private patient = new BehaviorSubject<any>(null)
  public patientId = this.patient.asObservable();

  constructor(private httpService: HttpService,
    private loader: LoaderService,
    private toastr: ToastrService) { }
  
  set(id){
      this.patient.next(id)
  }

  private sidebar = new BehaviorSubject<any>(true)
  public showSidebar = this.sidebar.asObservable();
  setSidebarSettings(flag){
    this.sidebar.next(flag);
  }

  private templates = new BehaviorSubject<any>(true)
  public allTemplates = this.templates.asObservable();
  public isTemplateAPICalled = false;
  getAllTemplates() {
    return new Promise((resolve, reject) => {
      this.loader.hide('progress');
      this.httpService.get('template')
        .subscribe((response: any) => {
          this.loader.hide('progress');
          this.isTemplateAPICalled = true;
          this.templates.next(response);
          resolve();
        }, error => {
          this.loader.hide('progress');
          this.toastr.warning(error, '', {
            progressBar: true, timeOut: 3000
          });
          reject();
        })
    })
  }
}
